import { useMemo } from "react";
import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];
const ANIMATE_TO = { opacity: 1, y: 0 };
const VIEWPORT = { once: true, margin: "-60px" };

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => {
  const initial = useMemo(() => ({ opacity: 0, y }), [y]);
  const transition = useMemo(() => ({ duration: 0.75, delay, ease: EASE }), [delay]);
  return (
    <motion.div
      className={className}
      initial={initial}
      whileInView={ANIMATE_TO}
      viewport={VIEWPORT}
      transition={transition}
    >
      {children}
    </motion.div>
  );
};
